/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { ICONS } from "src/app/core/constants/icons";
import * as ButtonSelectionActions from "../../../../../state/actions/button-click.actions";
import { BETTING_TASKS_TAB_MENU_ITEMS } from "src/app/core/constants/menuItems";
import { DialogService } from "src/app/core/services/dialog.service";
import { selectedBettingTasksFilterName } from "src/app/state/reducer/buttons.reducer";
import { ButtonsState } from "src/app/state/buttons-state";

@Component({
  selector: "app-betting-tasks-tabs",
  templateUrl: "./betting-tasks-tabs.component.html",
  styleUrl: "./betting-tasks-tabs.component.scss"
})
export class BettingTasksTabsComponent implements OnInit, OnDestroy {

  protected BETTING_TASKS = ICONS.HEADER_BETTING_TASKS;
  protected INFO_WHITE = ICONS.INFO_WHITE;
  protected bettingTasksMenuItems = BETTING_TASKS_TAB_MENU_ITEMS;

  private $selectedBettingTasksFilter = this.store.pipe(select(selectedBettingTasksFilterName));
  private moduleNameChangedSubscription: any;
  private selectedFilter: string = "";

  constructor(private store: Store<ButtonsState>,
    private dialogService: DialogService) { }

  ngOnInit(): void {
    this.moduleNameChangedSubscription = this.$selectedBettingTasksFilter.subscribe(selectedFilter => {
      this.selectedFilter = selectedFilter;
      this.isButtonSelected(this.selectedFilter);
    });
  }

  isButtonSelected(buttonName: string): boolean {
    return buttonName === this.selectedFilter;
  }

  openInfoModal() {
    this.dialogService.openConfirmation("", "Odigraj tikete za ispunjenje zadatka i osvoji MBC bodove!");
  }

  selectButton(buttonName: string): void {
    this.selectedFilter = buttonName;
    this.store.dispatch(ButtonSelectionActions.BETTING_TASKS_MODULE_SELECTED({ button: buttonName }));
  }

  ngOnDestroy(): void {
    this.moduleNameChangedSubscription.unsubscribe();
  }
}
